<template>
  <Drawer
    class="drawer_modal"
    width="700"
    v-model="showDrawer"
  >
    <!-- STORE DETAIL -->
    <storeDetail
      v-if="showDetailComponent"
      :id="itemId"
      :base_view_url="base_view_url"
      :item_type="item_type"
      @click_cancel="cancelAction"
      @click_edit="editAction"
      @reload_table="$emit('reload-table')"
    ></storeDetail>

    <!-- STORE EDIT/CREATE FORM -->
    <storeForm
      v-if="showFormComponent"
      v-model="itemId"
      :base_view_url="base_view_url"
      :action="itemAction"
      :item_type="item_type"
      @click_cancel="cancelAction"
      @show_detail="showDetail"
      @reload_table="$emit('reload-table')"
    ></storeForm>
  </Drawer>
</template>

<script>
import {BaseItemData} from "../../base/base_item.js";

import storeForm from "@/apps/store/storeForm.vue";
import storeDetail from "@/apps/store/storeDetail.vue";

let _app = BaseItemData();
_app.components = {
  storeForm,
  storeDetail
};
_app.data = function () {
  return {
    titles: {
      detail: "Магазин/склад",
      edit: "Редактирование магазина/склада",
      create: "Создание магазина/склада"
    },
    itemAction: "detail",
    itemId: "",
    showDrawer: false
  };
};
export default _app;
</script>

<style></style>



// WEBPACK FOOTER //
// src/apps/store/storeItem.vue